export function isUkCountry(country?: string | null): boolean {
  if (!country) return false;

  const normalized = country.trim().toLowerCase();
  return normalized === "uk" || normalized === "gb" || normalized === "united kingdom";
}
